const namespace = "inactivityTooltip";

export const INACTIVITY_LIMIT = `${namespace}.inactivityLimit`;
